import { jsx as _jsx } from "react/jsx-runtime";
import { SystemCard } from "./SystemCard";
import styles from "./SystemGrid.module.scss";
export function SystemGrid({ systems }) {
    if (systems.length === 0) {
        return _jsx("p", { className: styles.empty, children: "Inga system matchar filtret." });
    }
    return (_jsx("div", { className: styles.grid, children: systems.map((system) => (_jsx(SystemCard, { system: system }, system.id))) }));
}
